import OpticksSvgElement from "@/components/ui/OpticksSvgElement/OpticksSvgElement";
import type { OpticksSvgElementProps } from "@/components/ui/OpticksSvgElement/OpticksSvgElement.types";

// Collection: Tabler Icons
const HandClickIcon = ({
  className,
  size = 16,
  "aria-label": ariaLabel,
}: OpticksSvgElementProps) => (
  <OpticksSvgElement
    className={`icon-hand-click${className ? ` ${className}` : ""}`}
    size={size}
    aria-label={ariaLabel}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path
      d="M5.33334 8.66667V3C5.33334 2.73478 5.4387 2.48043 5.62624 2.29289C5.81377 2.10536 6.06813 2 6.33334 2C6.59856 2 6.85291 2.10536 7.04045 2.29289C7.22799 2.48043 7.33334 2.73478 7.33334 3V8"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.33334 7.66667V6.33334C7.33334 6.06812 7.4387 5.81377 7.62624 5.62623C7.81377 5.43869 8.06813 5.33334 8.33334 5.33334C8.59856 5.33334 8.85291 5.43869 9.04045 5.62623C9.22799 5.81377 9.33334 6.06812 9.33334 6.33334V8"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33331 7C9.33331 6.73478 9.43867 6.48043 9.62621 6.29289C9.81374 6.10536 10.0681 6 10.3333 6C10.5985 6 10.8529 6.10536 11.0404 6.29289C11.228 6.48043 11.3333 6.73478 11.3333 7V8"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.3333 7.66666C11.3333 7.40145 11.4387 7.14709 11.6262 6.95956C11.8138 6.77202 12.0681 6.66666 12.3333 6.66666C12.5985 6.66666 12.8529 6.77202 13.0404 6.95956C13.228 7.14709 13.3333 7.40145 13.3333 7.66666V10.6667C13.3333 11.7275 12.9119 12.7449 12.1618 13.4951C11.4116 14.2452 10.3942 14.6667 9.33333 14.6667H8H8.13867C7.47622 14.6668 6.82412 14.5024 6.24092 14.1882C5.65772 13.874 5.16168 13.4199 4.79733 12.8667L4.66667 12.6667C4.45867 12.3473 3.72867 11.0747 2.476 8.848C2.3483 8.62102 2.31419 8.35317 2.38092 8.10143C2.44765 7.84969 2.60997 7.63391 2.83333 7.5C3.07125 7.35724 3.35005 7.29807 3.62544 7.33189C3.90083 7.36571 4.15703 7.49058 4.35333 7.68666L5.33333 8.66666"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.33332 2L2.66666 1.33334"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.66667 4.66666H2"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33331 2L9.99998 1.33334"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 4H10.6667"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </OpticksSvgElement>
);

export default HandClickIcon;
